interface NumberedSanctionListProps {
  items: (string | undefined)[];
}

export function NumberedSanctionList({ items }: NumberedSanctionListProps) {
  return (
    <ul className="divide-y divide-gray-200 dark:divide-gray-700">
      {items.map((item, i) => (
        <li key={i} className="flex gap-2 py-1.5 first:pt-0 last:pb-0 text-sm text-gray-700 dark:text-gray-300">
          <span className="shrink-0">{i + 1}.</span>
          <span>{item || '-'}</span>
        </li>
      ))}
    </ul>
  );
}
